import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import styled, { css } from 'styled-components';

export const StyledHeader = styled.div<{
  $type?: 'select' | 'drag';
}>`
  display: flex;
  ${({ $type }) =>
    $type === 'drag'
      ? css`
          flex-direction: column;
        `
      : css`
          justify-content: space-between;
          align-items: center;
        `};
  gap: 0.5rem;
  margin-bottom: 0.75rem;
`;

export const StyledList = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('16', '24', 'BOLD')};
  color: ${pickThemeColor('BLACK_PRIMARY')};
  margin: 0;
`;
